<template>
  <label
    class="kt-checkbox kt-checkbox--single m-0 p-0"
    :class="[
      {'kt-checkbox--solid': solid},
      {'kt-checkbox-hidden': disabled && hideOnDisabled},
      labelClass
    ]"
  >
    <input
      :id="inputId"
      :value="value"
      :disabled="disabled"
      :readonly="readonly"
      :name="name"
      :checked="value"
      :tabindex="tabindex"
      type="checkbox"
      @change="onChange"
    >
    <span/>
  </label>
</template>

<script lang="ts">

export default {
  name: 'InputCheckbox',

  model: {
    prop: 'value',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    solid: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'input-checkbox'
    },
    inputId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      required: true
    },
    labelClass: {
      type: String,
      default: null,
    },
    tabindex: {
      type: String,
      default: '0'
    },
    hideOnDisabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onChange (e) {
      this.$emit('input', e.target.checked)
    }
  }
}
</script>

<style scoped lang="scss">
.kt-checkbox-hidden {
  display: none;
}

.kt-checkbox:has(input:disabled) {
  cursor: not-allowed !important;
}
</style>
